/**
 * 使用场景组件
 *
 * 终端风格展示四大使用场景
 * 小说创作、剧本编写、文案生成、文学分析
 */

import React from 'react';
import { homePageContent } from './homePageContent';

export const UseCases: React.FC = () => {
  const { useCases } = homePageContent;

  return (
    <section className="py-24 px-4 md:px-8 bg-ink-900 relative">
      <div className="max-w-6xl mx-auto relative z-10">
        {/* 标题区域 */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-ink-800 text-paper-400 text-sm font-medium mb-4 border border-ink-700">
            {useCases.badge}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {useCases.title}
          </h2>
          <p className="text-xl text-ink-400 max-w-2xl mx-auto">
            {useCases.subtitle}
          </p>
        </div>

        {/* 终端风格展示 */}
        <div className="bg-ink-950 rounded-2xl border border-ink-800 shadow-sm overflow-hidden">
          {/* 终端头部 */}
          <div className="flex items-center gap-2 px-4 py-3 bg-ink-900 border-b border-ink-800">
            <span className="w-3 h-3 rounded-full bg-red-500" />
            <span className="w-3 h-3 rounded-full bg-yellow-500" />
            <span className="w-3 h-3 rounded-full bg-green-500" />
            <span className="ml-4 text-sm text-ink-500 font-mono">starshine-cli</span>
          </div>

          {/* 终端内容 */}
          <div className="p-6 md:p-8 font-mono text-sm md:text-base">
            <div className="space-y-6">
              {useCases.examples.map((example, index) => (
                <div key={index} className="space-y-2">
                  <div className="flex items-start gap-2">
                    <span className="text-paper-400">➜</span>
                    <span className="text-paper-500">~</span>
                    <span className="text-ink-300">{example.command}</span>
                  </div>
                  <div className="pl-6 text-ink-400 border-l-2 border-ink-800">
                    {example.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 功能标签 */}
        <div className="flex flex-wrap justify-center gap-3 mt-12">
          {useCases.tags.map((tag, index) => (
            <span
              key={index}
              className="px-4 py-2 rounded-lg bg-ink-800 text-ink-300 text-sm border border-ink-700 hover:border-paper-500/50 hover:text-paper-400 transition-colors cursor-default"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
